import ReleaseOrderPausedBanner from './ReleaseOrderPausedBanner.component';

export default ReleaseOrderPausedBanner;
